export type SocialAccount = {
  id: string;
  network: "facebook" | "instagram";
  name: string;
  source: string;
};

export function accountLabel(a: SocialAccount): string {
  const net = a.network === "instagram" ? "Instagram" : "Facebook";
  const name = (a.name || "").trim();
  if (!name || name.toLowerCase() === net.toLowerCase()) return net;
  return `${net} · ${name}`;
}

export type SocialMedia = {
  id: string;
  kind: "image" | "video";
  url: string;
  preview?: string;
  name: string;
  frame?: string;
};

export type SocialPost = {
  id: string;
  caption: string;
  accounts: string[];
  media: SocialMedia[];
  status: "sent" | "scheduled";
  scheduled_at: string | null;
  sent_at: string | null;
  day: string;
};

export type SocialGroup = {
  id: string;
  name: string;
  accounts: string[];
};

export type LibraryItem = {
  id: string;
  kind: "image" | "video";
  name: string;
  url: string;
  thumb?: string;
  mime?: string;
};
